<template>
    <v-menu offset-y :close-on-content-click="false">
        <template #activator="{ on, attrs }">
            <v-btn
                rounded
                small
                outlined
                :color="following ? 'green' : 'default'"
                v-bind="attrs"
                @click="follow"
                v-on="on"
            >
                <v-icon small class="mr-1">mdi-plus</v-icon>
                <span v-if="following">Following</span>
                <span v-else>Follow</span>
            </v-btn>
        </template>
        <v-list v-if="following">
            <v-list-item v-for="(event, index) in events" :key="index">
                <template #default>
                    <v-list-item-action>
                        <v-checkbox
                            :input-value="following[`follow_${event.value}`]"
                            class="shrink mt-0"
                            hide-details
                            @change="value => toggleFollowEvent(event.value, value)"
                        />
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title>{{ event.title }}</v-list-item-title>
                    </v-list-item-content>
                </template>
            </v-list-item>
            <v-divider />
            <v-list-item selectable>
                <v-list-item-content style="cursor: pointer">
                    <v-list-item-title @click="unfollow">Unfollow</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import Athlete from '@/Models/Athlete.js';
import Club from '@/Models/Club.js';
import AthleteFollow from '@/Models/AthleteFollow.js';
import ClubFollow from '@/Models/ClubFollow.js';

export default {
    name: 'SFollow',

    props: {
        entity: {
            type: [Athlete, Club],
            required: true,
        },
    },

    data: () => ({
        events: [
            { title: 'Trampoline', value: 'tra' },
            { title: 'Double-Mini', value: 'dmt' },
            { title: 'Tumbling', value: 'tum' },
            { title: 'Synchro', value: 'syn' },
        ],
    }),

    computed: {
        following() {
            if (this.entity instanceof Athlete) {
                return AthleteFollow.query()
                    .where('user_id', this.$page.props.auth?.user?.id)
                    .where('athlete_id', this.entity.id)
                    .orderBy('id', 'desc')
                    .first();
            }

            return ClubFollow.query()
                .where('user_id', this.$page.props.auth?.user?.id)
                .where('club_id', this.entity.id)
                .orderBy('id', 'desc')
                .first();
        },
    },

    methods: {
        async follow() {
            if (this.following) {
                return;
            }

            if (this.entity instanceof Athlete) {
                await AthleteFollow.api().post('/api/follows', {
                    athlete_id: this.entity.id,
                });
            } else {
                await ClubFollow.api().post('/api/follows', {
                    club_id: this.entity.id,
                });
            }
        },

        async unfollow() {
            if (this.entity instanceof Athlete) {
                await AthleteFollow.api().delete(`/api/follows/${this.following.id}?entity=athlete`, {
                    delete: this.following.id,
                });
            } else {
                await ClubFollow.api().delete(`/api/follows/${this.following.id}?entity=club`, {
                    delete: this.following.id,
                });
            }
        },

        async toggleFollowEvent(event, value) {
            const events = {
                follow_tra: this.following.follow_tra,
                follow_dmt: this.following.follow_dmt,
                follow_tum: this.following.follow_tum,
                follow_syn: this.following.follow_syn,
            };

            events[`follow_${event}`] = value;

            if (this.entity instanceof Athlete) {
                await AthleteFollow.api().put(`/api/follows/${this.following.id}`, {
                    ...events,
                    entity: 'athlete',
                });
            } else {
                await ClubFollow.api().post(`/api/follows/${this.following.id}`, {
                    ...events,
                    entity: this.entity.follow_entity,
                });
            }
        },
    },
};
</script>
